import { render, staticRenderFns } from "./TAlert.vue?vue&type=template&id=4fa3626e"
import script from "./TAlert.vue?vue&type=script&lang=js"
export * from "./TAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports